export default __webpack_public_path__ + "static/hero_2-4312507ec89b86c7914ec9f179d0175c.png";